// Generated by _scripts/i18n/generate-namespaces.js — do not edit.
//
// Regenerate with `pnpm i18n:namespaces` after adding or removing a
// translation namespace file. The list mirrors the en-CA locale
// directory; check-key-parity.js enforces that the other locales match.

export const NAMESPACES = [
  'access-control',
  'common',
  'imd-programs',
  'message-board',
  'micare',
  'nav',
  'offers',
  'pages',
  'recalls',
  'routes',
  'ui',
  'vehicle-catalog',
] as const;

export type Namespace = (typeof NAMESPACES)[number];
